<template>
  <div class="c-calendar-info">
    <div class="info-wrapper">
      <div v-if="showInfo" class="shadow" @click="showInfo = false" />
      <div class="info-button" @click="showInfo = !showInfo">
        <div class="image-place">
          <img :src="imgInfo">
        </div>
        <div class="title">Инфо</div>
      </div>

      <div v-if="showInfo" class="types-popover">
        <div class="top-part">
          <div class="title-top">{{title}}</div>
          <div class="close-icon" @click="showInfo = false">
            <img :src="imgClose" />
          </div>
        </div>
        <div class="types-wrapper">
          <div v-for="item in types" :key="item.title" class="type">
            <div
              class="circle"
              :style="'background-color:'+item.color+';'+'background-image:'+item.color+';'"
            >
              {{ item.reduction }}
            </div>
            <span class="title">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgInfo from '../../assets/new/info-icon.svg'
import imgClose from '../../assets/new/close-icon.svg'

export default {
  name: 'CCalendarInfo',
  props: {
    title: {
      type: String,
      default: 'Информация по слотам',
    },
    types: {
      type: Array,
      default: () => {
        return [
          { title: 'До трудоустройства', value: 'beforeWork', color: '#999999', reduction: 'ДТ', },
          { title: 'Рабочий день', value: '', color: '#ffffff', reduction: 'РД', },
          { title: 'Праздник', value: 'celebrate', color: '#FFAF36', reduction: 'ПД', },
          { title: 'Нетрудоспособность (болезнь, карантин и т.д)', value: 'sickLeave', color: '#3AE2CE', reduction: 'НТ', },
          { title: 'Выходной день', value: 'weekend', color: '#CFCECE', reduction: 'ВД', },
          { title: 'Трудовой отпуск', value: 'laborLeave', color: '#F1CB04', reduction: 'ТО', },
          { title: 'Командировка', value: 'businessTrip', color: '#7C1DC9', reduction: 'К', },
          { title: 'Присутствовал', value: 'was', color: '#64C038', reduction: 'П', },
          { title: 'Присутствовал в выходной', value: 'wasInWeekend', color: 'linear-gradient(315deg, #64C038 45%, #CFCECE 65%)', reduction: 'ПВ', },
          { title: 'Отпуск без сохранение заработной платы', value: 'freeVacation', color: '#FAFF00', reduction: 'ОП', },
          { title: 'Командировка выходного дня', value: 'weekendBusinessTrip', color: '#9F79C8', reduction: 'КВ', },
          { title: 'Пропуск', value: 'wasnt', color: '#FF0000', reduction: 'ПР', },
          { title: 'Отпуски в связи с родами (без сох. з/п)', value: 'maternityLeave', color: '#FF008A', reduction: 'ОР', },
          { title: 'Расторжение ТД', value: 'terminationTD', color: '#606060', reduction: 'РТ', },
          { title: 'Опоздал', value: 'late', color: '#A70F61', reduction: 'О', },
          { title: 'Дополнительный отпуск', value: 'additionalVac', color: '#BD5306', reduction: 'ДО', },
        ]
      },
    },
  },
  data() {
    return {
      imgInfo,
      imgClose,
      value: this.checked,
      showInfo: false,
    }
  },
  methods: {
  },
}
</script>

<style scoped lang="scss">
.c-calendar-info {
  .shadow {
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }

  .info-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 0 16px;
    border: 2px solid var(--primary);
    border-radius: 12px;
    margin-left: 16px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    color: var(--primary);

    .image-place {
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .info-wrapper {
    position: relative;
    display: inline-block;

    .top-part {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .title-top {
        font-weight: 700;
        font-size: 16px;
      }
    }

    .types-popover {
      position: absolute;
      top: 60px;
      right: 0;
      z-index: 1000;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 12px;
      padding: 24px;
      width: 600px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }

  }

  .types-wrapper {
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 20px;

    .type {
      margin-top: 5px;
      display: flex;
      align-items: center;

      &:last-child {
        margin-right: 0;
      }

      .circle {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border-radius: 4px;
        border: 1px solid #dcdcdc;
        width: 34px;
        height: 34px;
        padding: 0 2px;
        background-color: #64C038;
        margin-right: 5px;
        color: #fff;
        font-size: 14px;
      }

      .title {
        font-weight: 400;
        height: 100%;
        line-height: 1;
        color: #000000;
        font-size: 14px;
        width: 100%;
      }
    }
  }
}
</style>
